module.exports = __webpack_public_path__ + "static/media/logostatic.4702f800.png";